<template>
<div class="overlay" >
  <div class="upload-image-wrapper">
   <div class="close"><button v-on:click="$store.showUploadFlagDialog=false">X</button></div>
   <div v-if="!$store.changeDeleteImage" class="upload-image-head">Upload Image</div>
   <div v-else class="update-image-head">Update Image</div>
   <div class="upload-image-body">
    <p>Allowed formats are jpeg and png.</p>
    <img v-bind:src="$store.uploadDialogImgSrc" id="image-view-placeholder" width="120px" height="120px" :style="{'visibility':$store.uploadDialogImgSrc!=''?'visible':'hidden'}" >
    <input type="file" name="pic" accept="image/*" style="display:none" v-on:change="readURL($event)" ref="imageFile">
   </div>
   <div v-if="$store.changeDeleteImage" class="delete-change-image-buttons">
    <button type="button" name="change" v-on:click="$store.changeDeleteImage=false" >Change</button>
    <button type="button" name="Delete" v-on:click="deleteAttachment" >Delete</button>
   </div>
   <div v-else class="upload-image-buttons">
    <button type="button" name="browse" v-on:click="browse" :style="{display:browseButtonDisplay}" >Browse</button>
    <button type="button" name="Upload" v-on:click="upload" :style="{display:uploadButtonDisplay}" >Upload</button>
   </div>
   <div v-if="errorOccured" style="color:red;font-size:12px">oops! some error occured!!!</div>
  </div>
</div>
</template>

<script>
export default {
  name: 'UploadFlag',
  data() {
  return {
  browseButtonDisplay:'block',
  uploadButtonDisplay:'none',
  file:'',
  errorOccured:false
  }
},
methods : {
     browse(){
     this.$refs.imageFile.click();
     },
     readURL(input) {
       var vm = this;
       input=input.path[0]
       if (input.files && input.files[0]) {
           var reader = new FileReader();

           reader.onload = function (e) {
               vm.$store.uploadDialogImgSrc = e.target.result;
               vm.browseButtonDisplay = 'none';
               vm.uploadButtonDisplay = 'block';
           }

           reader.readAsDataURL(input.files[0]);
       }
   },
   upload(){
    this.file = this.$refs.imageFile.files[0];
    var formData = new FormData();
    formData.append('file', this.file);
    formData.append('index', 0);

    var vm = this;

    if(!vm.$store.languageFlagSrc[vm.$store.currentLanguageId]){
      this.$http.post("languages/" + this.$store.currentLanguageId + "/attachment",formData,
      {
        headers:{
          'content-Type':'multipart/form-data'
        }
      }).then(function(r){
        vm.$set(vm.$store.languageFlagSrc,vm.$store.currentLanguageId,vm.$store.uploadDialogImgSrc);
        vm.$set(vm.$store.languageFlagExist, vm.$store.currentLanguageId, true);
        vm.$store.showUploadFlagDialog=false;
        vm.$store.uploadDialogImgSrc='';
      }).catch(function(){
        vm.errorOccured=true;
      });
    }
    else{
      this.$http.put("/languages/" + this.$store.currentLanguageId + "/flag",
      formData,
      {
        headers:{
          'content-Type':'multipart/form-data'
        }
      }).then(function(r){
        vm.$set(vm.$store.languageFlagSrc,vm.$store.currentLanguageId,vm.$store.uploadDialogImgSrc);
        vm.$store.showUploadFlagDialog=false;
        vm.$store.uploadDialogImgSrc='';
      })
      .catch(function(){
        
      });
    }
   },
   deleteAttachment(){
    var attachment = this.$store.dialogHasAttachment[this.$store.currentDialogId];
    var vm =  this;
    this.$http.delete("languages/" + this.$store.currentLanguageId + "/attachment").then(function(r){  
      vm.$delete(vm.$store.languageFlagSrc,vm.$store.currentLanguageId);
      vm.$set(vm.$store.languageFlagExist, vm.$store.currentLanguageId, false);
      vm.$store.showUploadFlagDialog=false;
      })
    }
   }
  }
</script>

<style scoped>
.overlay{
width:100vw;
height:100vh;
position:fixed;
top:0;
left:0;
background:rgba(0,0,0,.4);
z-index:999;
cursor:initial;
}
.upload-image-wrapper{
display:grid;
box-shadow:2px 2px 3px #888;
left:calc(50% - 150px);
top:calc(50% - 150px);
margin:-8px;
width:300px;;
height:300px;
position:fixed;
padding:10px;
text-align:center;
color:dimgray;
background:#f7f7f7;
z-index:10;
animation: grow .25s;
}

@keyframes grow {
  from {
    transform: scale(0.75) ;
  }
  to {
    transform:  scale(1) ;
  }
}

.close{
width:20px;
height:20px;
position:absolute;
right:5px;
top:0px;
}
.close button{
background:none;
border:0px;
font-weight:600;
}
 button:hover{
cursor:pointer;
}
.upload-image-head,.update-image-head{
padding:10px;
font-size:26px;
}

.upload-image-buttons button{
 border:0px;
 color:white;
 padding:10px 0px;
 width:80%;
 background:#0098ff;
 left:10%;
 position:relative;
}
.delete-change-image-buttons{
display:inline;
}
.delete-change-image-buttons button{
border:0px;
color:white;
padding:10px 0px;
width:40%;
background:#0098ff;
}
</style>
